// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iSJXTmX0o3rspvmSz990{max-width:1280px;margin:0 auto;padding:0 20px;width:100%;box-sizing:border-box}`, "",{"version":3,"sources":["webpack://./src/Pages/ai/styles.styl"],"names":[],"mappings":"AAAA,sBACI,gBAAU,CACV,aAAO,CACP,cAAQ,CACR,UAAM,CACN,qBAAW","sourcesContent":[".container\n    max-width 1280px\n    margin 0 auto\n    padding 0 20px\n    width 100%\n    box-sizing border-box"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `iSJXTmX0o3rspvmSz990`
};
export default ___CSS_LOADER_EXPORT___;
